import styled from 'styled-components';
import { customMedia } from 'styles/utils';

import { MOBILE_HEIGHT } from 'apps/components/header/header.styled';

import Button from 'components/Button';
import { Avatar } from 'components';

export const OuterWrapper = styled.div`
  width: 440px;
  min-height: 12rem;
  max-height: calc(100vh - 112px);
  padding: ${props => props.theme.spacing.default};
  background-color: ${props => props.theme.color.wfWhite};
  overflow-x: hidden;
  overflow-y: auto;
`;

export const MobileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 12rem;
  height: calc(100vh - ${MOBILE_HEIGHT * 2 + 2}px);
  max-height: calc(100vh - ${MOBILE_HEIGHT * 2 + 2}px);
`;

export const FullPageWrapper = styled.div`
  font-size: 14px;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${props => props.theme.spacing.default};
`;

export const CardsWrapper = styled.div`
  overflow-x: visible;

  ${customMedia.lessThan('large')`
    overflow-x: auto;
    height: 100%;
    max-height: calc(100vh - ${MOBILE_HEIGHT * 3 + 2}px);
  `}

  ${customMedia.greaterThan('large')`
    margin-top: ${props => props.theme.spacing.default};
  `}
`;

export const CardWrapper = styled.div`
  position: relative;
  display: flex;
  padding: ${props => props.theme.spacing.default};
  font-size: ${props => props.theme.font.size.small};
  cursor: ${props => (props.isActionable ? 'default' : 'pointer')};
  background-color: ${props =>
    props.isRead ? props.theme.color.wfWhite : props.theme.color.wfGrey100};
  border-bottom: 1px solid ${props => props.theme.color.wfGrey300};
`;

export const CreatorAvatar = styled(Avatar)`
  width: 30px;
  height: 30px;
  margin-right: ${props => props.theme.spacing.default};
  display: inline-block;
  vertical-align: top;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ContentRowWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: baseline;

  time {
    font-size: ${props => props.theme.font.size.small};
    color: ${props => props.theme.color.wfGrey400};
    margin-left: ${props => props.theme.spacing.small};
  }

  a {
    color: ${props => props.theme.color.wfBlack};
    font-weight: 600;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const MinimalSpan = styled.span`
  color: ${props => props.theme.color.wfGrey500};
`;

export const ButtonStyled = styled(Button)`
  margin: ${props => props.theme.spacing.small};
`;

export const MobileFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: ${MOBILE_HEIGHT}px;
  padding: 0 ${props => props.theme.spacing.default};
  border-top: ${props => `1px solid ${props.theme.color.wfGrey200}`};
`;

export const ErrorWrapper = styled.div`
  margin: ${props => props.theme.spacing.default};
`;
